import React from 'react';
import Form from "react-bootstrap/Form";

const AdministrativeAttrsForm = ({amd, fields, handleFieldChange,
                                  memStatus, setMemStatus,
                                  savedType, memType, handleMemTypeChanged,
                                  memClass, setMemClass,
                                  memPost, setMemPost, handleMemPostChange,
                                  memCommittee, setMemCommittee, handleMemCommitteeChange,
                                  memPaymentMethod, setMemPaymentMethod, 
                                  memRepresentative, setMemRepresentative, handleMemRepresentativeChange,
                                  memStatus4Label, messages, page, isEdit}) => {
  const hideCheckItemClass = (type) => {
    console.log('memType = ' + memType + ' , type = ' + type + ', savedType = ' + savedType);
    if (memType == 9 || memType == 12 || memType == 13) {
      if (savedType == 4 || savedType == 5 || savedType == 6 || savedType == 10) {
	     if (type == 4 || type == 5 || type == 6 || type == 10 || type == 12 || type == 13)
               return "";
             else
               return "hideCkItem";
      }
      if (savedType == 1 || savedType == 2 || savedType == 3) {
	     if (type == 1 || type == 2 || type == 3 || type == 9 || type == 12 || type == 13)
               return "";
             else
               return "hideCkItem";
      }
    } 

    if (type == 14 || type == 15 || type == 16 || type == 17) {
      if (savedType == 14 || savedType == 15 || savedType == 16 || savedType == 17)
        return "";
      else
        return "hideCkItem";
    }

    if (memType == 3) {
      if (type == 4 || type == 5 || type == 6 || type == 7 || type == 8 || type == 10 || type == 11)
        return "hideCkItem";
    }
    if (memType == 6) {
      if (type == 1 || type == 2 || type == 3 || type == 7 || type == 8 || type == 9 || type == 11)
        return "hideCkItem";
    }
    if (memType == 1 || memType == 2) {
      if (type == 4 || type == 5 || type == 6 || type == 7 || type == 8 || type == 9 || type == 10 || type == 11)
        return "hideCkItem";
    }
    if (memType == 4 || memType == 5 || memType == 6 || memType == 10) {
      if (type == 1 || type == 2 || type == 3 || type == 7 || type == 8 || type == 9  || type == 11)
        return "hideCkItem";
    }
    if (memType == 7 || memType == 8 || memType == 11) {
      if (type == 1 || type == 2 || type == 3 || type == 4 || type == 5 || type == 6 || type == 9  || type == 10)
        return "hideCkItem";
    }

    if (memType == 14 || memType == 15 || memType == 16 || memType == 17) {
	if (type == 1 || type == 2 || type == 3 || type == 4 || type == 5 || type == 6 || type == 7 || type == 8 || type == 9 || type == 10 || type == 11 || type == 12 || type == 13) return "hideCkItem";
    }
    return "";
  };

  const isShowOptions = () => {
    return (memType != 1 && memType != 2 /* && memType != 3 */&& memType != 4 && memType != 5 && memType != 6);
  };

  return (
    <>
              <h2>事務局使用欄</h2>
              <dl>
                <dt>会員番号</dt>
                <dd>
                  <Form.Group controlId="loginId" size="lg">
                    <Form.Control
                      disabled={ memType == 7 || memType == 8 || memType == 11 }
                      type="text"
                      name="loginId"
                      value={fields.loginId}
                      onChange={handleFieldChange}
                    />
                  </Form.Group>
                  <p id="loginIdMessage" className="errorMessages">{messages.loginId.n}</p>
                </dd>
                <dt>入会申請日</dt>
                <dd>
                  <Form.Group controlId="admissionRequestDate" size="lg">
                    <Form.Control
                      disabled={ memType == 7 || memType == 8 || memType == 11 }
                      type="text"
                      value={fields.admissionRequestDate}
                      onChange={handleFieldChange}
                    />
                  </Form.Group>
                  <p>例: 2021/08/20</p>
                  <p id="admissionRequestDateMessage" className="errorMessages">{messages.admissionRequestDate.n}</p>
                </dd>
                <dt>入会日</dt>
                <dd>
                  <Form.Group controlId="admissionDate" size="lg">
                    <Form.Control
                      disabled={ memType == 7 || memType == 8 || memType == 11 }
                      type="text"
                      value={fields.admissionDate}
                      onChange={handleFieldChange}
                    />
                  </Form.Group>
                  <p>例: 2021/08/20</p>
                  <p id="admissionDateMessage" className="errorMessages">{messages.admissionDate.n}</p>
                </dd>
                <dt className="hiddenRow">状態</dt>
                <dd className="hiddenRow">
                  <Form.Group size="lg">
                    <Form.Check
                      inline
                      label="申込"
                      name="memStatus"
                      id="memStatus1"
                      type="radio"
                      value="1"
                      checked={ 1 == memStatus }
                      onChange={ (e) => setMemStatus(e.target.value) }
                    />
                    <Form.Check
                      inline
                      label="仮入会"
                      name="memStatus"
                      id="memStatus2"
                      type="radio"
                      value="2"
                      checked={ 2 == memStatus }
                      onChange={ (e) => setMemStatus(e.target.value) }
                    />
                    <Form.Check
                      inline
                      label="審査中"
                      name="memStatus"
                      id="memStatus3"
                      type="radio"
                      value="3"
                      checked={ 3 == memStatus }
                      onChange={ (e) => setMemStatus(e.target.value) }
                    />
                    <Form.Check
                      inline
                      label={ memStatus4Label ? memStatus4Label : "登録完了" }
                      name="memStatus"
                      id="memStatus4"
                      type="radio"
                      value="4"
                      checked={ 4 == memStatus }
                      onChange={ (e) => setMemStatus(e.target.value) }
                    />
                  </Form.Group>
                </dd>
                <dt className={ memType == 93 || memType == 96 ? "hideInputRow" : "" }>会員種別</dt>
                <dd className={ memType == 93 || memType == 96 ? "hideInputRow" : "" }>
                  <Form.Group size="lg">
                    <Form.Check
                      inline
                      label="申込（正会員）"
                      name="memType"
                      type="radio"
                      value="1"
                      className={ hideCheckItemClass(1) }
                      checked={ 1 == memType }
                      onChange={ handleMemTypeChanged }
                    />
                    <Form.Check
                      inline
                      label="仮入会（正会員）"
                      name="memType"
                      type="radio"
                      value="2"
                      className={ hideCheckItemClass(2) }
                      checked={ 2 == memType }
                      onChange={ handleMemTypeChanged }
                    />
                    <Form.Check
                      inline
                      label="正会員"
                      name="memType"
                      type="radio"
                      value="3"
                      className={ hideCheckItemClass(3) }
                      checked={ 3 == memType }
                      onChange={ handleMemTypeChanged }
                    />
                    <Form.Check
                      inline
                      label="申込（准会員）"
                      name="memType"
                      type="radio"
                      value="4"
                      className={ hideCheckItemClass(4) }
                      checked={ 4 == memType }
                      onChange={ handleMemTypeChanged }
                    />
                    <Form.Check
                      inline
                      label="審査中（准会員）"
                      name="memType"
                      type="radio"
                      value="10"
                      className={ hideCheckItemClass(10) }
                      checked={ 10 == memType }
                      onChange={ handleMemTypeChanged }
                    />
                    <Form.Check
                      inline
                      label="仮入会（准会員）"
                      name="memType"
                      type="radio"
                      value="5"
                      className={ hideCheckItemClass(5) }
                      checked={ 5 == memType }
                      onChange={ handleMemTypeChanged }
                    />
                    <Form.Check
                      inline
                      label="准会員"
                      name="memType"
                      type="radio"
                      value="6"
                      className={ hideCheckItemClass(6) }
                      checked={ 6 == memType }
                      onChange={ handleMemTypeChanged }
                    />
                    <Form.Check
                      inline
                      label="申請（准会員から正会員）"
                      name="memType"
                      type="radio"
                      value="7"
                      className={ hideCheckItemClass(7) }
                      checked={ 7 == memType }
                      onChange={ handleMemTypeChanged }
                    />
                    <Form.Check
                      inline
                      label="審査中（准会員から正会員）"
                      name="memType"
                      type="radio"
                      value="11"
                      className={ hideCheckItemClass(11) }
                      checked={ 11 == memType }
                      onChange={ handleMemTypeChanged }
                    />
                    <Form.Check
                      inline
                      label="正会員（准会員から移行）"
                      name="memType"
                      type="radio"
                      value="8"
                      className={ hideCheckItemClass(8) }
                      checked={ 8 == memType }
                      onChange={ handleMemTypeChanged }
                    />
                    <Form.Check
                      inline
                      label="名誉会員"
                      name="memType"
                      type="radio"
                      value="9"
                      className={ hideCheckItemClass(9) }
                      checked={ 9 == memType }
                      onChange={ handleMemTypeChanged }
                    />
                    <Form.Check
                      inline
                      label="寄贈"
                      name="memType"
                      type="radio"
                      value="12"
                      className={ hideCheckItemClass(12) }
                      checked={ 12 == memType }
                      onChange={ handleMemTypeChanged }
                    />
                    <Form.Check
                      inline
                      label="購読者"
                      name="memType"
                      type="radio"
                      value="13"
                      className={ hideCheckItemClass(13) }
                      checked={ 13 == memType }
                      onChange={ handleMemTypeChanged }
                    />
                    <Form.Check
                      inline
                      label="申込（学生会員）"
                      name="memType"
                      type="radio"
                      value="14"
                      className={ hideCheckItemClass(14) }
                      checked={ 14 == memType }
                      onChange={ handleMemTypeChanged }
                    />
                    <Form.Check
                      inline
                      label="審査中（学生会員）"
                      name="memType"
                      type="radio"
                      value="17"
                      className={ hideCheckItemClass(17) }
                      checked={ 17 == memType }
                      onChange={ handleMemTypeChanged }
                    />
                    <Form.Check
                      inline
                      label="仮入会（学生会員）"
                      name="memType"
                      type="radio"
                      value="15"
                      className={ hideCheckItemClass(15) }
                      checked={ 15 == memType }
                      onChange={ handleMemTypeChanged }
                    />
                    <Form.Check
                      inline
                      label="学生会員"
                      name="memType"
                      type="radio"
                      value="16"
                      className={ hideCheckItemClass(16) }
                      checked={ 16 == memType }
                      onChange={ handleMemTypeChanged }
                    />
                  </Form.Group>
                </dd>
                <dt className={ amd == 'req' || memType == 93 || memType == 96 ? "hideInputRow" : "" }>会員区分</dt>
                <dd className={ amd == 'req' || memType == 93 || memType == 96 ? "hideInputRow" : "" }>
                  <Form.Group size="lg">
                    <Form.Check
                      inline
                      label="現在会員"
                      name="memClass"
                      type="radio"
                      value="1"
                      checked={ 1 == memClass }
                      onChange={ (e) => setMemClass(e.target.value) }
                    />
                    <Form.Check
                      inline
                      label="退会"
                      name="memClass"
                      type="radio"
                      value="2"
                      checked={ 2 == memClass }
                      onChange={ (e) => setMemClass(e.target.value) }
                    />
                    <Form.Check
                      inline
                      label="退会（物故）"
                      name="memClass"
                      type="radio"
                      value="3"
                      checked={ 3 == memClass }
                      onChange={ (e) => setMemClass(e.target.value) }
                    />
                    <Form.Check
                      inline
                      label="退会（除名）"
                      name="memClass"
                      type="radio"
                      value="4"
                      checked={ 4 == memClass }
                      onChange={ (e) => setMemClass(e.target.value) }
                    />
                    <Form.Check
                      inline
                      label="休会中"
                      name="memClass"
                      type="radio"
                      value="5"
                      checked={ 5 == memClass }
                      onChange={ (e) => setMemClass(e.target.value) }
                    />
                  </Form.Group>
                </dd>
                <dt className={ isShowOptions() ? "associatem" : "associatem hideInputRow" }>会員区分備考</dt>
                <dd className={ isShowOptions() ? "associatem" : "associatem hideInputRow" }>
                  <Form.Group controlId="classRemarks" size="lg">
                    <Form.Control
                      as="textarea"
                      value={ fields.classRemarks }
                      onChange={handleFieldChange}
                    />
                  </Form.Group>
                </dd>
                <dt className={ isShowOptions() ? "associatem" : "associatem hideInputRow" }>役職</dt>
                <dd className={ isShowOptions() ? "associatem" : "associatem hideInputRow" }>
                  <Form.Group size="lg">
                    <Form.Check
                      inline
                      label="理事長"
                      name="memPost0"
                      type="checkbox"
                      value="1"
                      checked={ 1 == memPost[0] }
                      onChange={handleMemPostChange}
                    />
                    <Form.Check
                      inline
                      label="副理事長"
                      name="memPost1"
                      type="checkbox"
                      value="2"
                      checked={ 2 == memPost[1] }
                      onChange={handleMemPostChange}
                    />
                    <Form.Check
                      inline
                      label="理事"
                      name="memPost2"
                      type="checkbox"
                      value="3"
                      checked={ 3 == memPost[2] }
                      onChange={handleMemPostChange}
                    />
                    <Form.Check
                      inline
                      label="監事"
                      name="memPost3"
                      type="checkbox"
                      value="4"
                      checked={ 4 == memPost[3] }
                      onChange={handleMemPostChange}
                    />
                    <Form.Check
                      inline
                      label="委員長"
                      name="memPost4"
                      type="checkbox"
                      value="5"
                      checked={ 5 == memPost[4] }
                      onChange={handleMemPostChange}
                    />
                  </Form.Group>
                </dd>
                <dt className={ isShowOptions() ? "associatem" : "associatem hideInputRow" }>委員会</dt>
                <dd className={ isShowOptions() ? "associatem" : "associatem hideInputRow" }>
                  <Form.Group size="lg">
                    <Form.Check
                      inline
                      label="総務委員会"
                      type="checkbox"
                      name="memCommittee0"
                      value="1"
                      checked={ 1 == memCommittee[0] }
                      onChange={handleMemCommitteeChange}
                    />
                    <Form.Check
                      inline
                      label="財務委員会"
                      type="checkbox"
                      name="memCommittee1"
                      value="2"
                      checked={ 2 == memCommittee[1] }
                      onChange={handleMemCommitteeChange}
                    />
                    <Form.Check
                      inline
                      label="学術委員会"
                      name="memCommittee2"
                      type="checkbox"
                      value="3"
                      checked={ 3 == memCommittee[2] }
                      onChange={handleMemCommitteeChange}
                    />
                    <Form.Check
                      inline
                      label="編集委員会"
                      type="checkbox"
                      name="memCommittee3"
                      value="4"
                      checked={ 4 == memCommittee[3] }
                      onChange={handleMemCommitteeChange}
                    />
                    <Form.Check
                      inline
                      label="教育研修委員会"
                      type="checkbox"
                      name="memCommittee4"
                      value="5"
                      checked={ 5 == memCommittee[4] }
                      onChange={handleMemCommitteeChange}
                    />
                    <Form.Check
                      inline
                      label="資格審査委員会"
                      type="checkbox"
                      name="memCommittee5"
                      value="6"
                      checked={ 6 == memCommittee[5] }
                      onChange={handleMemCommitteeChange}
                    />
                    <Form.Check
                      inline
                      label="倫理・COI委員会"
                      type="checkbox"
                      name="memCommittee6"
                      value="7"
                      checked={ 7 == memCommittee[6] }
                      onChange={handleMemCommitteeChange}
                    />
                    <Form.Check
                      inline
                      label="オリンピック・パラリンピック等準備委員会"
                      type="checkbox"
                      name="memCommittee7"
                      value="8"
                      checked={ 8 == memCommittee[7] }
                      onChange={handleMemCommitteeChange}
                    />
                    <Form.Check
                      inline
                      label="国際委員会"
                      type="checkbox"
                      name="memCommittee8"
                      value="9"
                      checked={ 9 == memCommittee[8] }
                      onChange={handleMemCommitteeChange}
                    />
                    <Form.Check
                      inline
                      label="広報委員会"
                      type="checkbox"
                      name="memCommittee9"
                      value="10"
                      checked={ 10 == memCommittee[9] }
                      onChange={handleMemCommitteeChange}
                    />
                  </Form.Group>
                </dd>

        <dt className={ isShowOptions() ? "associatem" : "associatem hideInputRow" }>役職・委員会（旧表記）</dt>
        <dd className={ isShowOptions() ? "associatem" : "associatem hideInputRow" }>
          <Form.Group controlId="postAndCommittee" size="lg">
            <Form.Control
              type="text"
              name="postAndCommittee"
              value={fields.postAndCommittee}
              onChange={handleFieldChange}
            />
          </Form.Group>
        </dd>

        <dt className={ isShowOptions() ? "associatem" : "associatem hideInputRow" }>委員会活動履歴</dt>
        <dd className={ isShowOptions() ? "associatem" : "associatem hideInputRow" }>
          <Form.Group controlId="committeeActiveHistories" size="lg">
            <Form.Control
              type="text"
              name="committeeActiveHistories"
              value={fields.committeeActiveHistories}
              onChange={handleFieldChange}
            />
          </Form.Group>
        </dd>

                <dt className={ isShowOptions() ? "associatem" : "associatem hideInputRow" }>代議員</dt>
                <dd className={ isShowOptions() ? "associatem" : "associatem hideInputRow" }>
                  <Form.Group size="lg">
                    <Form.Check
                      inline
                      label="代議員"
                      name="memRepresentative0"
                      type="checkbox"
                      value="1"
                      checked={ 1 == memRepresentative[0] }
                      onChange={handleMemRepresentativeChange}
                    />
                  </Form.Group>
                </dd>
        <dt className={ isShowOptions() ? "associatem" : "associatem hideInputRow" }>代議員任期</dt>
        <dd className={ isShowOptions() ? "associatem" : "associatem hideInputRow" }>
          <Form.Group controlId="termOfRepresentative" size="lg">
            <Form.Control
              type="text"
              name="termOfRepresentative"
              value={fields.termOfRepresentative}
              onChange={handleFieldChange}
            />
          </Form.Group>
        </dd>

                <dt className="associatem" style={ memType != 3 && memType != 7 && memType != 8 && memType != 9 && memType != 11 ? {display:"none"} : {} }>理事・監事任期</dt>
                <dd className="associatem" style={ memType != 3 && memType != 7 && memType != 8 && memType != 9 && memType != 11 ? {display:"none"} : {} }>
                  <Form.Group controlId="termOfDirective" size="lg">
                    <Form.Control
                      type="text"
                      value={fields.termOfDirective}
                      onChange={handleFieldChange}
                    />
                  </Form.Group>
                  <p>例: 2021/08/20</p>
                  <p id="termOfDirectiveMessage" className="errorMessages">{messages.termOfDirective.n}</p>
                </dd>

        <dt>学会賞</dt>
        <dd>
          <Form.Group controlId="academicAwards" size="lg">
            <Form.Control
              type="text"
              name="academicAwards"
              value={fields.academicAwards}
              onChange={handleFieldChange}
            />
          </Form.Group>
        </dd>

        <dt>振込先情報</dt>
        <dd>
          <Form.Group controlId="accountPayable" size="lg">
            <Form.Control
              type="text"
              name="accountPayable"
              value={fields.accountPayable}
              onChange={handleFieldChange}
            />
          </Form.Group>
        </dd>

        <dt>所属履歴</dt>
        <dd>
          <Form.Group controlId="teamHistories" size="lg">
            <Form.Control
              type="text"
              name="teamHistories"
              value={fields.teamHistories}
              onChange={handleFieldChange}
            />
          </Form.Group>
        </dd>

        <dt>退会日</dt>
        <dd>
          <Form.Group controlId="unsubscribeDate" size="lg">
            <Form.Control
              type="text"
              name="unsubscribeDate"
              value={fields.unsubscribeDate}
              onChange={handleFieldChange}
            />
          </Form.Group>
        </dd>

          <dt>入金方法</dt>
                <dd>
                  <Form.Group size="lg">
                    <Form.Check
                      inline
                      label="郵便振込"
                      name="memPaymentMethod"
                      type="radio"
                      value="1"
                      checked={ 1 == memPaymentMethod }
                      onChange={ (e) => setMemPaymentMethod(e.target.value) }
                    />
                    <Form.Check
                      inline
                      label="自動引落"
                      name="memPaymentMethod"
                      type="radio"
                      value="2"
                      checked={ 2 == memPaymentMethod }
                      onChange={ (e) => setMemPaymentMethod(e.target.value) }
                    />
                  </Form.Group>
                </dd>

        <dt>発送物</dt>
        <dd>
          <Form.Group controlId="shipments" size="lg">
            <Form.Control
              type="text"
              name="shipments"
              value={fields.shipments}
              onChange={handleFieldChange}
            />
          </Form.Group>
        </dd>

                <dt className="" style={ memType != 7 && memType != 8 && memType != 11 ? {display:"none"} : {} }>准会員より正会員への変更日</dt>
                <dd className="" style={ memType != 7 && memType != 8 && memType != 11 ? {display:"none"} : {} }>
                  <Form.Group controlId="transitionDate" size="lg">
                    <Form.Control
                      type="text"
                      value={fields.transitionDate}
                      onChange={handleFieldChange}
                    />
                  </Form.Group>
                  <p>例: 2021/08/20</p>
                  <p id="transitionDateMessage" className="errorMessages">{messages.transitionDate.n}</p>
                </dd>


                <dt>備考</dt>
                <dd>
                  <Form.Group controlId="remarks" size="lg">
                    <Form.Control
                      as="textarea"
                      value={ fields.remarks }
                      onChange={handleFieldChange}
                    />
                  </Form.Group>
                </dd>
              </dl>
    </>
  );
}

export default AdministrativeAttrsForm;
